export const dispatchEvent = (
    object: Record<string, { formats: Record<string, string> }>
) => {
    // Apple WebView notification
    (window as any)?.webkit?.messageHandlers?.ReactNativeWebView?.postMessage(
        JSON.stringify(object),
    );
    // Android WebView notification
    (window as any)?.ReactNativeWebView?.postMessage(
        JSON.stringify(object),
    );
}
